import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import style from './style.css';
//import FontAwesome from 'react-fontawesome';
import { Icon } from '../../Icon';
import * as CardComponents from '../';
import CommentCardComponent from '../Comment';
import ImageLightbox from '../../../Common/ImageLightbox';
import Filters from '../../../../other/filters';
import cx from '../../../../styles';
import { gtmSend } from '../../../../helpers';
import BlockUnblockUser from '../../BlockUnblockUser';

export class ReplyFeedCardComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { readMore: false }
    }

    readMore = () => {
        this.setState({ readMore: true });
    }

    componentDidMount() {
        this.props.setCardName('Question Reply Card');
    }

    render() {
        
        const { reply, responseBar, t } = this.props;
        const { ActionLink, ResponseBar } = CardComponents;
        const author = reply.user;
        const lastSeen = reply.nice_time;
        const actions = reply.actions;
        const message = reply.message ? reply.message.replace(/<script.*>.*<\/script>/ims, " ").replace(/<script[\s\S]*?>/gi, '') : '';

        return (
            <div className={cx("post-section", "reply-card-component", "reply-feed-card-component")}>
                {
                    author.designation_type !== 0 && author.designation &&
                    <div className={cx('designation')}>
                        <span style={{ borderColor: author.designation_color_code, background: author.designation_color_code, color: author.designation_text_color_code}}>{author.designation}</span>
                    </div>
                }

                <div className={cx("reply-card-top")}>
                    <aside className={cx("rct-left")}>
                        <div className={cx("last-seen")}>
                            <span>
                                {t('answered')}
                                {
                                    lastSeen != "" &&
                                    <a href={this.props.url} onClick={() => {this.props.cardName && gtmSend('dynmic', this.props.cardName, 'click-date', this.props.match.path)}}>
                                        {lastSeen}
                                    </a>
                                }
                            </span>
                            {
                                author.fullname && author.fullname.toLowerCase() != 'anonymous' &&
                                <span>
                                    {t('by')}
                                    <a href={this.props.siteUrl + author.slug} rel="nofollow" className={cx('reply-author-feed')}>
                                        {author.fullname}
                                    </a>
                                </span>
                            }
                        </div>
                    </aside>

                    <aside className={cx("rct-right", actions && !actions.length ? "hide" : "")}>
                        <ActionLink actions={actions} cardName={this.props.cardName} match={this.props.match}/>
                    </aside>
                </div>

                <div className={cx("post-section-body")}>
                    <div className={cx("reply-text", "text-desc")}>
                        <div><a href={this.props.url} className={cx("question-card-link",(!this.state.readMore && message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) && !this.state.readMore  ? 'content-text-crop':'')} dangerouslySetInnerHTML={{__html: Filters.process(['linkify'], message)}}></a></div>

                        { (message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) && !this.state.readMore ? <span className={cx('read-more-reply')} onClick={this.readMore}> {t('lp_read_more')}</span> : "" }
                    </div>

                    {
                        reply.images && reply.images.length > 0 &&
                        <div className={cx("img-blur-wrap")}>
                            <div style={{backgroundImage:'url('+ reply.images[0].thumbnail +')'}}></div>
                            <ImageLightbox images={reply.images} type={reply.images[0].type} imageAltText={'Post reply image'} height="200" width="420" />
                        </div>
                    }

                    <ResponseBar isReply={true}
                        replyUrl={reply.url}
                        isCrawler={this.props.appReducer.isCrawler}
                        likes={responseBar.likes}
                        dislikes={responseBar.dislikes}
                        replyCount={responseBar.replyCount}
                        onLikeClick={responseBar.onLikeClick}
                        onDislikeClick={responseBar.onDislikeClick}
                        onReplyClick={responseBar.onReplyClick}
                        onShareClick={responseBar.onShareClick} />

                </div>
            </div>
        );
    }

}

class ReplyCardComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { readMore: false, isOpen: false, coverReply: false, showReply: true }
    }

    readMore = () => {
        this.setState({ readMore: true });
    }

    onActionClick = () =>{
        this.setState({ isOpen: true });
    }
    toggleModal = () => {
        this.setState({ isOpen: false });
    }

    toggleReply = () => {
        if(this.props.reply.comments.length > 0){
            window.location.reload();
        }else{
            this.setState({ coverReply: false });
        }
    }

    onMoreCommentClick = () => {
        if(!this.props.userId) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `read more comment | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `read more comment | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            gtmSend('dynamic', this.props.cardName, 'click-more-comments', this.props.match.path)
            this.props.onCommentsFetch();
        }
    }
    
    componentDidMount() {
        this.props.setCardName('Reply Card');
        if(this.props.reply.block_user && this.props.reply.block_user.user_id === this.props.userId && this.props.reply.block_user.anonymous_status === 0){
            this.setState({ coverReply: true });
        }else if(this.props.reply.block_user && (this.props.reply.block_user.user_id !== this.props.userId || this.props.reply.block_user.anonymous_status)){
            this.setState({ showReply: false });
        }
    }

    render() {
        const { reply, responseBar, t, status, likeErrorMessage } = this.props;
        const { AuthorLink, LastSeen, ActionLink, ResponseBar } = CardComponents;
        const author = reply.user;
        const lastSeen = reply.nice_time;
        const actions = reply.actions;
        const message = reply.message ? reply.message.replace(/<script.*>.*<\/script>/ims, " ").replace(/<script[\s\S]*?>/gi, '') : '';
        const replyStatus = reply.status;

        return (
            this.state.showReply &&
            <div className={cx("post-section", "reply-card-component", this.state.coverReply? "cover" : "")}>
                {
                    author.designation_type !== 0 && author.designation &&
                    <div className={cx('designation')}>
                        <span style={{ borderColor: author.designation_color_code, background: author.designation_color_code }}>{author.designation}</span>
                    </div>
                }

                {
                    this.state.coverReply && 
                    <div className={cx('block-reply-overlay-wrapper')}>
                        <p>{t('blocked_post')} <span onClick={this.onActionClick}>{t('here')}</span></p>
                    </div>
                }

                {
                    reply.block_user && 
                    <BlockUnblockUser entityType={'profile'} entityId={author.id} status={0} userName={author.fullname} userId={author.id} id={reply.id} isOpen={this.state.isOpen} cardName={this.props.cardName} postId={this.props.postId} topic={this.props.topic} toggleModal={this.toggleModal} blockUser={false} toggleReply={this.toggleReply} blockReply={true}/>
                }


                <div className={cx("reply-card-top")}>
                    <aside className={cx("rct-left")}>
                        {
                            lastSeen != "" &&
                            <LastSeen isSingleReplyLastSeen={this.props.isSingleReplyLastSeen} lastSeen={lastSeen} url={this.props.url} cardName={this.props.cardName} match={this.props.match}/>
                        }

                        <AuthorLink id={author.id} 
                            slug={author.slug ? this.props.siteUrl + author.slug : ''} 
                            url={author.url} 
                            fullName={author.fullname}
                            tagLine={author.tagline} 
                            imageUrl={author.image}
                            cardName={this.props.cardName}
                            match={this.props.match} />
                    </aside>
                {
                    status == 1 &&
                    <aside className={`${status == 0? cx("rct", actions && !actions.length ? "hide" : "") : cx("rct-right", actions && !actions.length ? "hide" : "")}`}>
                        <ActionLink actions={actions} cardName={this.props.cardName} match={this.props.match} id={this.props.replyId} topic={this.props.topic}/>
                    </aside>
                }
                </div>

                <div className={cx("post-section-body")}>
                    <div className={cx("reply-text", "text-desc")}>
                        <p className={cx((!this.state.readMore && message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) && !this.state.readMore  ? 'content-text-crop':'','not-infeed-reply')} dangerouslySetInnerHTML={{__html: Filters.process(['linkify'], message)}}></p>

                        { (message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) && !this.state.readMore ? <span className={cx('read-more-reply')} onClick={this.readMore}> {t('lp_read_more')}</span> : "" }
                    </div>

                    {
                        reply.images && reply.images.length > 0 &&
                        <div className={cx("img-blur-wrap")}>
                            <div style={{backgroundImage:'url('+ reply.images[0].thumbnail +')'}}></div>
                            <ImageLightbox images={reply.images} type={reply.images[0].type} imageAltText={'Post reply image'} height="200" width="420" />
                        </div>
                    }
                    <ResponseBar isReply={true}
                        replyUrl={reply.url}
                        isCrawler={this.props.appReducer.isCrawler}
                        likes={responseBar.likes}
                        dislikes={responseBar.dislikes}
                        replyCount={responseBar.replyCount}
                        onLikeClick={responseBar.onLikeClick}
                        onDislikeClick={responseBar.onDislikeClick}
                        onReplyClick={responseBar.onReplyClick}
                        onShareClick={responseBar.onShareClick}
                        status={status}
                        replyStatus={replyStatus}
                        likeErrorMessage={likeErrorMessage}
                        />

                    {
                        reply.comments.length != 0
                            ?
                            <div className={cx("reply-comments")}>
                                {
                                    !!reply.more_comment_count &&
                                    <div className={cx("more-reply-link")}>
                                        <div onClick={this.onMoreCommentClick}>
                                            <span>{reply.more_comment_count + ' ' + (reply.more_comment_count > 1 ? t('detail_more_comments') : t('detail_more_comment_single'))}</span>

                                            <Icon name="dropdown-icon" className="more-comments-arrow" />

                                            { this.props.isCommentsLoading && !this.props.appReducer.showLoginModal && <span className={cx("spin-loader")} /> }
                                        </div>
                                    </div>
                                }
                                {
                                    reply.comments.map((comment, i) => {
                                        return <CommentCardComponent 
                                                    key={i} 
                                                    t={t}
                                                    comment={comment}
                                                    siteUrl={this.props.siteUrl}
                                                    cardName='Reply Comment Card'
                                                    match={this.props.match}
                                                    userId={this.props.userId}
                                                    postId={this.props.postId} 
                                                    topic={this.props.topic}
                                                    status={status} />
                                    })
                                }
                            </div>
                            :
                            ""
                    }

                </div>
            </div>
        );
    }

}

export default ReplyCardComponent;
